import { Component, OnInit } from '@angular/core';
import { ApiService } from '../utilities/services/api.service';
import { LocaleService } from '@app/system/services/locale.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { CheckBoxModel } from '@app/components/controls/utilities/models/check-box-model';
import { TextAreaModel } from '@app/components/controls/utilities/models/text-area-model';

@Component({
	selector: 'app-conversation-update',
	templateUrl: './conversation-update.component.html',
	styleUrls: ['./conversation-update.component.scss']
})
export class ConversationUpdateComponent implements OnInit {

	action: 'rejectConversation';
	formFields: any = [];
	config = { fxFlex: 100 };
	title;
	info;
	formObject;
	submitDisable = true;
	loader = true;
	popupRef;
	currentUser;
	conversationData;
	formPopup = true;

	constructor(
		private apiService: ApiService,
		private gfService: GlobalFunctionService,
		public locale: LocaleService,
	) {
		this.currentUser = this.gfService.sessionUser;
	}

	ngOnInit(): void {
		if (this.action === 'rejectConversation') {
			this.title = this.locale.translate('reject_post');
			this.info = this.locale.translate('reject_post_info');
			const policyDeviation: CheckBoxModel = {
				fieldColumn: 'policyDeviation',
				additionalMetaData: {
					showLabel: true,
					min: 1
				},
				fieldType: 'checkBox',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				value: null,
				options: [{
					key: this.locale.translate('abusive_language'),
					value: this.locale.translate('abusive_language')
				},
				{
					key: this.locale.translate('out_of_context'),
					value: this.locale.translate('out_of_context')
				},
				{
					key: this.locale.translate('political_overtone'),
					value: this.locale.translate('political_overtone')
				},
				{
					key: this.locale.translate('too_long'),
					value: this.locale.translate('too_long')
				},
				{
					key: this.locale.translate('too_short'),
					value: this.locale.translate('too_short')
				}
				],
				fieldCaption: this.locale.translate('policy_deviation'),
				fieldOrder: 1,
				fieldPlaceholder: this.locale.translate('policy_deviation')
			};

			const remarks: TextAreaModel = {
				fieldColumn: 'remarks',
				fieldCaption: this.locale.translate('remarks'),
				additionalMetaData: {
					maxChar: 250,
					fieldConfig: {
						appearance: 'standard',
						floatLabel: 'auto'
					}
				},
				fieldType: 'textArea',
				isHidden: false,
				isReadonly: false,
				isRequired: true,
				value: null,
				validationRegex: null,
				fieldPlaceholder: this.locale.translate('remarks'),
				fieldOrder: 2
			};

			this.formFields = [policyDeviation, remarks];
			this.submitDisable = false;
			this.loader = false;
		}
	}

	submit() {
		// if (this.action === 'rejectConversation') {
		// 	this.updateConversation();
		// }
	}



	updateConversation() {
		// if (this.formObject && this.formObject.form) {
		// 	this.submitDisable = true;
		// 	const headers: any = {};
		// 	this.gfService.alertClear('conversationAlert');
		// 	if (this.formObject.form.valid) {
		// 		this.loader = true;
		// 		const formData: any = this.gfService.fieldSubmitApiValueConstruct(
		// 			this.formObject.form.getRawValue(),
		// 			this.formObject.fields
		// 		);
		// 		formData.userList = formData.toUserIDArray;
		// 		const UserIds = formData.toUserIDArray.map((data) => {
		// 			return data.key.userID;
		// 		});
		// 		const apiData = this.gfService.JSONMerge(formData, { toUserID: formData.toUserIDArray[0].key.userID });
		// 		this.apiService
		// 			.updatePost(apiData, this.conversationData.recordId, headers)
		// 			.subscribe(
		// 				(response) => {
		// 					this.popupRef.close(this.gfService.JSONMerge(apiData, response));
		// 					this.gfService.openSnackBar('SUCCESS', {
		// 						message: this.locale.translate('rerquest_sent'),
		// 						icon: 'check_circle_outline',
		// 						position: 'before'
		// 					});
		// 				},
		// 				(error) => {
		// 					this.gfService.formErrorHandler(error, this.formObject.form);
		// 					this.gfService.alertHandler(error, 'conversationAlert', 'ERROR');
		// 				}
		// 			)
		// 			.add(() => {
		// 				this.submitDisable = false;
		// 				this.loader = false;
		// 			});
		// 	} else {
		// 		this.gfService.fieldControlMarkAsTouched(this.formObject.fields, this.formObject.form);
		// 		this.submitDisable = false;
		// 	}
		// }
	}

	formObjectReader(record: any) {
		this.formObject = record;
	}

}
